@if (guidedTourService.shouldShowTourForCurrentRoute()) {
  <div (click)="guidedTourService.startTourForCurrentRoute(); showTooltip.set(false)"
    (mouseenter)="showTooltip.set(true)" (mouseleave)="showTooltip.set(false)"
    [ngClass]="{'!bottom-5': isDefaultPosition()}" class="hidden fixed bottom-36 right-5 z-10 xl:flex items-center">
    @if (showTooltip()) {
      <div class="bg-[#005aa8] -mr-5 p-3 rounded-s-full shadow transition-opacity duration-500"
        style="white-space: nowrap;">
        <span class="mr-4 px-2 text-white text-sm font-medium">
          Inicie o tutorial clicando aqui
        </span>
      </div>
    }

    <div
      class="size-12 bg-[#005aa8] rounded-full hover:scale-110 transition-all delay-100 flex items-center justify-center cursor-pointer">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="size-8 text-white">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
        </svg>
      </div>
    </div>
  }
